import React from "react"
import { Carousel } from "react-responsive-carousel"
import "./Carousel.css"

export default ({photos}) => {

    return(
      <div className="app">
        <Carousel className="carousel-wrapper" infiniteLoop showThumbs={false} stopOnHover={false} autoPlay swipeable={false}>
    {photos.map((photo, i) => (
      <div key={i}
      className="image-container"
      style={{
        backgroundImage: `url(${photo.photo})`
      }}
      >
      <p className="legend">{photo.text}</p>
        </div>
    ))}
  </Carousel>
    </div>
    )
}
